import React, {useEffect} from 'react';
import settings from '../../config/settings'
import TriggerAPI from '../../models/trigger'
import { ModalContext } from '../../context/modal'
import DeleteCommunicationModal from '../modals/campaigns/DeleteCommunicationModal'

export default function TriggerPanel(props) {
    let { toggleModal, setModalContent } = React.useContext(ModalContext);

    useEffect(() => {
        // console.log('SimpleResponsePanel', props.expand);
    }, [props.expand]);

    const renderDeleteTriggerModal = (data) => {
        setModalContent(DeleteCommunicationModal({
            hide: () => toggleModal(false),
            success: () => {toggleModal(false);},
            rerender: p => renderDeleteTriggerModal(p),
            action: (type, payload) => {
                TriggerAPI().destroy(data.id)
                    .then(res => {
                        if (res.data.statusCode === 200) {
                            toggleModal(false);
                            props.deleteCommunication(data.cId, data.id, 'TRIGGER');
                        } else {
                            props.setError(res.data.message);
                        }
                    })
                    .catch(res => {
                        props.setError(res.data.message);
                    });
            },
            name: (data && data.name) || '',
            type: 'Correspondence',
            error: (data && data.error) || '',
            campaign: (data && data.campaign) || {}
        }));
        toggleModal(true);
    }

    return (
        <div className="panel-section-content">
            <div className="panel panel-default panel-section-header">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-md-4 col-xs-12">Correspondences</div>
                        <div className="col-md-8 hidden-xs"></div>
                    </div>
                </div>
            </div>
            <div className="panel panel-default panel-section-records row">
                {
                    props.data.map(trigger => (
                        <div key={'trigger' + trigger._id} className={["row panel-section-record", props.communicationStatusClasses[trigger.status], props.expand].join(" ")}>
                            <div className="col-md-1"></div>
                            <div className="col-md-11 panel-section-record-row">
                                {/* <div className="panel-heading panel-heading-campaign row record" onClick={_ => props.setRedirectTo(`${settings.subPath}/correspondences/${trigger.triggerId}/${props.campaignId}/${props.index}`)}> */}
                                <div className="panel-heading panel-heading-campaign row record" onClick={_ => props.renderCommunicationModal(props.campaignId, props.index, trigger.triggerId)}>
                                    <div className="col-md-3 col-xs-8 highligted-text">{trigger.name}</div>
                                    <div className="col-md-2 hidden-sm hidden-xs">{trigger.frequency}</div>
                                    <div className="col-md-2 hidden-sm hidden-xs">{trigger.shortCodeId}</div>
                                    <div className="col-md-3 hidden-sm hidden-xs">
                                        <span>
                                            { (trigger.frequency === 'Once') ? 
                                                props.formatDateString(trigger.dateDetails) : 
                                                props.formatDateString(trigger.startDate) } { trigger.endDate ? `- ${props.formatDateString(trigger.endDate)}` : '' }
                                        </span>
                                    </div>
                                    <div className="col-md-2 col-xs-4 text-right">
                                        {(trigger.status === 'DISABLED') && (
                                            <span className="fa-wrap highligted-text-green">
                                                <i className="fa fa-play fa-lg" onClick={(evt) => props.setCommunicationStatus(evt, trigger, 'TRIGGER')} title="Activate Correspondence"></i>
                                            </span>
                                        )}
                                        {(trigger.status === 'DISABLED' && trigger.lastExecuted === null) && (
                                            <span className="fa-wrap">
                                                <i className="fa fa-trash-o fa-lg" onClick={evt => {evt.stopPropagation(); renderDeleteTriggerModal({name: trigger.name, id:trigger._id, cId: trigger.campaignId})}} title="Delete Correspondence"></i>
                                            </span>
                                        )}
                                        {(trigger.status === 'ACTIVE') && (
                                            <span className="fa-wrap highligted-text-red">
                                                <i className="fa fa-stop fa-lg" onClick={evt => props.setCommunicationStatus(evt, trigger, 'TRIGGER')} title="Deactivate Correspondence"></i>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
                
            </div>
        </div>
    )
}
